import React from 'react';
import links from 'utils/links';
import { Link } from 'react-router-dom';

const TagNames = ({ items = [], history }) => {
  let tagNames = items.map((item, i) => (
    <Link key={'item' + i} to={links.searchLink(item)}>
      <span
        key={'item' + i}
        style={{
          color: 'rgba(0,0,0,0.87)',
          fontSize: '1.089375rem',
          // lineHeight: '28px',
          // letterSpacing: '0.5px',
          fontWeight: '400',
          fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
        }}
      >
        <u
          style={{
            fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
          }}
        >
          {item}
        </u>
        <span>{i !== items.length - 1 ? ', ' : ''}</span>
      </span>
    </Link>
  ));
  return <div>{tagNames}</div>;
};

export default TagNames;
